const DPI = 72;
const CM_PER_INCH = 2.54;

export const convertCmToPxInPdf = (valueInCm: number) =>
  valueInCm * (1 / CM_PER_INCH) * DPI;
